export default __webpack_public_path__ + "static/matches-09929175c65ef066e6cdb46d96cbb879.png";